import clsx from 'clsx';
import { useCallback } from 'react';
import { infoIconYellow } from '../../assets/hostedassets';
import { REFRESH_UNLOCK_POS } from '../../store/investor/constants';
import { Button } from '../_custom';
import Tooltip from '../_custom/Tooltip/Tooltip';
import { STALE_STRIP_VARIANT } from './constants';
import type { StaleDataStripProps } from './types';
import styles from './StaleDataStrip.module.scss';

const StaleDataStrip = ({ variant, copy, onOpenUnlockRefresh, className }: StaleDataStripProps) => {
    const isDesktop = variant === STALE_STRIP_VARIANT.DESKTOP;
    const handleClick = useCallback(() => onOpenUnlockRefresh(REFRESH_UNLOCK_POS.STALE_DATA_STRIP), [onOpenUnlockRefresh]);
    const icon = <img src={infoIconYellow} alt="" aria-hidden="true" className={styles.InfoIcon} />;
    const row = (
        <span className={styles.Row}>
            <span className={styles.Dot} aria-hidden="true" />
            <span className={styles.LabelText}>{copy.label}</span>
            {isDesktop ? (
                <Tooltip content={copy.tooltipText} direction="right" usePortal>
                    {icon}
                </Tooltip>
            ) : (
                icon
            )}
        </span>
    );

    return (
        <Button
            type="button"
            text={row}
            aria-label={copy.ariaLabel}
            onClick={handleClick}
            className={clsx(styles.Strip, isDesktop ? styles.Desktop : styles.Mobile, className)}
        />
    );
};

export default StaleDataStrip;
